import { MatPaginatorIntl } from '@angular/material/paginator';
import { LanguageService } from '../core/language.service';
import { Injectable } from '@angular/core';

@Injectable()
export class TranslatedPaginator extends MatPaginatorIntl {
  constructor(private readonly languageService: LanguageService) {
    super();

    let ofText = '';
    const loadLabels = () =>
      this.languageService.translateAsync('paginator').then((translations) => {
        this.itemsPerPageLabel = translations.itemsPerPage;
        this.nextPageLabel = translations.nextPage;
        this.previousPageLabel = translations.previousPage;
        ofText = translations.of;
        this.changes.next();
      });
    loadLabels();
    this.languageService.languageChanged.subscribe(() => loadLabels());

    this.getRangeLabel = function (page, pageSize, length) {
      if (length === 0 || pageSize === 0) {
        return '0 ' + ofText + ' ' + length;
      }
      length = Math.max(length, 0);
      const startIndex = page * pageSize;
      // If the start index exceeds the list length, do not try and fix the end index to the end.
      const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
      return startIndex + 1 + ' - ' + endIndex + ' ' + ofText + ' ' + length.toLocaleString();
    };
  }
}
